import { render, staticRenderFns } from "./FooterCookies.vue?vue&type=template&id=bece54b8&scoped=true&"
import script from "./FooterCookies.vue?vue&type=script&lang=js&"
export * from "./FooterCookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bece54b8",
  null
  
)

export default component.exports